import type { UserType } from '@/types/domains/index';

export default defineNuxtRouteMiddleware(async () => {
  if (import.meta.client) {
    const currentUser = useAuth().currentUser.value as UserType.User;
    await useUserAddress().fetchUserAddresses(currentUser.id);

    const userAddresses = useUserAddress().userAddresses.value;
    const invalidAddresses = userAddresses.filter(
      (address: UserType.UserAddress) => !address.isValidPostalCode
    );

    if (invalidAddresses.length > 0) {
      const invalidPostalCodeInformation: string = invalidAddresses
        .map(
          (address: UserType.UserAddress) =>
            `郵便番号: ${address.postalCode1}-${address.postalCode2}は現在使われておりません。`
        )
        .join('\n');
      sessionStorage.setItem('invalidPostalCodes', invalidPostalCodeInformation);

      return navigateTo('/mypage/mypage-base');
    }
  }
});
